<template>
  <template v-if="type === 'card'">
    <div
      class="tw-absolute tw-top-[calc(4.5rem-1px)] -tw-left-1 tw-bg-primary tw-size-1 tw-brightness-75 tw-pointer-events-none"
    />
    <div
      class="tw-absolute tw-left-[calc(4.5rem-1px)] -tw-top-1 tw-bg-primary tw-size-1 tw-brightness-75 tw-pointer-events-none"
    />
    <div
      class="tw-absolute -tw-top-1 -tw-left-1"
      :class="isEMH ? 'tw-z-3 game-primary-text' : 'tw-text-primary-text'"
    >
      <component
        :is="tooltip ? 'TooltipHover' : 'div'"
        fixed
        position="bottom"
        background="success"
        :text="tooltip"
      >
        <div class="tw-relative tw-size-20 tw-pointer-events-auto">
          <svg
            class="tw-size-20 tw-rounded"
            viewBox="0 0 80 80"
            xmlns="http://www.w3.org/2000/svg"
            style="filter: drop-shadow(0px 4px 2px rgba(0, 0, 0, 0.2))"
          >
            <path
              d="M 0 0 L 80 0 L 0 80 L 0 0"
              :fill="isEMH ? 'var(--primary-button-color)' : 'var(--primary)'"
            />
          </svg>
          <font-awesome-icon
            icon="book"
            size="lg"
            class="tw-absolute tw-left-2 tw-top-2"
          />
          <span
            class="tw-text-xxs tw-uppercase tw-font-medium tw-absolute tw-left-[42%] tw-top-[41%] tw-whitespace-nowrap"
            style="transform: translate(-50%, -50%) rotate(-45deg)"
          >
            {{ $t('marketplace.purchased') }}
          </span>
        </div>
      </component>
    </div>
  </template>
  <template v-else-if="type === 'admin'">
    <svg
      class="tw-size-8 tw-rounded"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M 0 0 L 32 0 L 0 32 L 0 0" fill="var(--primary)" />
    </svg>
    <font-awesome-icon
      icon="store"
      size="xs"
      class="tw-absolute tw-left-1 tw-top-1 tw-text-primary-text"
    />
  </template>
</template>

<script>
import TooltipHover from '@components/Message/TooltipHover.vue'
import { isEMH } from '@config'

export default {
  components: {
    TooltipHover,
  },
  props: {
    type: {
      type: String,
      required: true,
      validator: (val) => ['card', 'admin'].includes(val),
    },
    tooltip: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {
      isEMH,
    }
  },
}
</script>
